module.exports = __webpack_public_path__ + "static/media/art-sample-2.df69d806.png";